import {Injectable} from '@angular/core';
import notify from "devextreme/ui/notify";
@Injectable()
export class ResponseFilterService {

    constructor() {
    }

    public doFilter(filtred) {
        return filtred.toPromise()
            .catch(e=>{
                notify(e.message,'error');
                return Promise.reject(e);
            })
            .then(e=>{
                if(!e.action) {
                    notify('Непонятный ответ Сервера','error');
                    return Promise.reject(e);
                } else if(e.action=='error'){
                    notify(e.message,'error');
                    return Promise.reject(e);
                }
                else return Promise.resolve(e);
            })
    }

}



// WEBPACK FOOTER //
// ./src/app/services/response-filter.service.ts